"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
// NOTE https://github.com/tc39/proposal-regexp-match-indices
const regexp_match_indices_1 = __importDefault(require("regexp-match-indices"));
const errors_1 = require("../errors");
const Span = __importStar(require("../span"));
function create(table) {
    for (const [label, regexp] of table) {
        if (regexp.global) {
            throw new Error("Can not use RegExp with global property in TableLexer.\n" +
                `label: ${label}\n` +
                `regexp: ${regexp.toString()}\n`);
        }
    }
    return {
        table,
        lex(text) {
            const tokens = new Array();
            let i = 0;
            while (i < text.length) {
                const remain = text.slice(i);
                const result = match_table(remain, table);
                if (result !== undefined) {
                    const { label, value, span, forword } = result;
                    if (forword === 0) {
                        throw new errors_1.LexingError(`No progress during at: ${i}\n` +
                            `remain: ${report_remain(remain)}\n` +
                            `label: ${result.label}\n`);
                    }
                    tokens.push({
                        label,
                        value,
                        span: Span.shift(span, i),
                    });
                    i += forword;
                }
                else {
                    throw new errors_1.LexingError("All regexp in table fail to match remaining input.\n" +
                        `index: ${i}\n` +
                        `remain: ${report_remain(remain)}\n` +
                        `labels: ${table.map(([label]) => label).join(", ")}\n`);
                }
            }
            return tokens;
        },
    };
}
exports.create = create;
function report_remain(remain) {
    let s = "";
    s += remain.slice(0, 20).replace(/\n/g, "\\n");
    s += " ...";
    return s;
}
function match_table(text, table) {
    for (const [label, regexp] of table) {
        const result = (0, regexp_match_indices_1.default)(regexp, text);
        if (result !== null) {
            // NOTE The first capture is viewed as the value of the token.
            const value = result[1];
            if (value !== undefined) {
                const main = result[0];
                const forword = main.length;
                const [lo, hi] = result.indices[1];
                const span = { lo, hi };
                return { label, value, span, forword };
            }
        }
    }
}
//# sourceMappingURL=table-lexer-create.js.map